import { Watch } from "react-loader-spinner";
import { palette } from "../assets/theme/theme";


export default function RodrimaqSpinner({ message, height } : {message?: string, height?: number}) {

    return (<div style={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', justifyContent: 'center', height: height?height:300 }}>
        <Watch
            height="100"
            width="100"
            color={palette.rodrimaq_red}
            ariaLabel='loading'
        />
        <div style={{ marginTop: 20 }}>
            <span style={{ color: palette.rodrimaq_red, fontSize: '1.4em' }}>{message ? message : 'A preparar dados...'}</span>
        </div>
    </div>)

}